import { render, staticRenderFns } from "./RelacaoBolsistas.vue?vue&type=template&id=9b6635c6"
import script from "./RelacaoBolsistas.vue?vue&type=script&lang=js"
export * from "./RelacaoBolsistas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports